import { AmlFlowEnum } from '@/api';
import { RISK_GROUPS } from '@/config';
import { RiskDetails, RiskType } from '@/models';
import isFlowLimited from './isFlowLimited';

export default function getRiskGroups(
  signals: Record<string, number>,
  flow: AmlFlowEnum,
) {
  const groups: Record<string, any> = {};
  let allowedRiskGroups = Object.keys(RISK_GROUPS);

  if (isFlowLimited(flow)) {
    allowedRiskGroups = allowedRiskGroups.filter(
      (riskLevel: string) => riskLevel !== 'danger',
    );

    allowedRiskGroups.reverse();
  }

  allowedRiskGroups.forEach((riskLevel: string) => {
    const entries: RiskDetails[] = [];
    const groupSignals = RISK_GROUPS[riskLevel as RiskType];

    groupSignals.forEach((signalKey: any) => {
      const val = signals[signalKey] ? Number(signals[signalKey]) * 100 : 0;

      if (val > 0) {
        entries.push({
          label: signalKey,
          value: Number(val.toFixed(1)),
        });
      }
    });

    if (entries.length > 0) {
      groups[riskLevel] = entries;
    }
  });

  return groups;
}
